import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import illustration from './assets/priceAlertPromptIllustration.png'
import {Illustration} from './styles'

interface Props {
  hotelName: string
  /** Localized current price for the body, with its basis, e.g. "€394 / night". */
  priceLabel: string
}

/** The scrollable body of the prompt: illustration, title and description. */
export const PriceAlertPromptContent = ({hotelName, priceLabel}: Props) => (
  <>
    <Illustration
      src={illustration.src}
      alt=""
      aria-hidden
      width={358}
      height={120}
    />

    <Box paddingTop="s600">
      <Text variant="titleXL" align="center">
        <FormattedMessageWrapper
          id="priceAlertPrompt.title"
          defaultMessage="Want to track this price?"
        />
      </Text>

      <Box paddingTop="s200">
        <Text variant="bodyM" align="center">
          <FormattedMessageWrapper
            id="priceAlertPrompt.description"
            defaultMessage="You don’t need to keep checking {hotelName}. We can monitor the price and let you know if it changes from {price}."
            values={{hotelName, price: priceLabel}}
          />
        </Text>
      </Box>
    </Box>
  </>
)
